module.exports = __webpack_public_path__ + "img/papillary-reaction-1.ea9c64b8.jpg";